import { useState, useContext, useEffect }  from 'react'
import { SceneContext } from './SceneContext'
import { useHistory }  from 'react-router-dom'
import { CSSTransition } from 'react-transition-group'
import MiniPlayer   from './MiniPlayer'

import './css/AudioBox.css'

export default function AudioBox(props) {

    const [state, setState] = useState({
        img_folder: 'images/',
        box_color: getRandomColor(),
        opacity: 'opacity-off',
        flash: false
    })

    const context = useContext(SceneContext)
    const history = useHistory()

    return (
        <div className={'audioBox'}>
            { render_imgs(props, state, setState, context, history) }
            <MiniPlayer index={props.index} data={props.data.audio} color={state.box_color}></MiniPlayer>
        </div>
    )
}

function computeImgStyle(data, state, context, props) {
    let is_active = context.audioboxes_state[props.index]
    //let filter = 'sepia(100%)'
    let filter = ''

    if(data.type == 'main')
        if(is_active) 
            filter = 'drop-shadow(2px 2px 0px rgba(0, 0, 0, 0.5)) '
        else
            filter = 'drop-shadow(2px 2px 0px rgba(0, 0, 0, 0.5))'
    
    if(data.no_filter)
        filter = ''

    filter = '' 

    let style = { 
                    top: data.y,
                    left: data.x, 
                    transform: data.transform, 
                    border: context.dev_mode? ('1px solid ' + state.box_color) : ('1px solid rgba(0,0,0,0)'),
                    transition: (data.transition || '') + ', scale 0.4s',
                    filter: filter
                }
    
    if (context.dev_mode == false) {

        if(is_active && data.type == 'main')
            if(data.hide == false)
                style.opacity = 1
            else
                style.opacity = 0
        else if(is_active && data.type == 'hover')
            style.opacity = 1
        else if(!is_active && data.type == 'main')
            style.opacity = 1
        else if(!is_active && data.type == 'hover')
            style.opacity = 0
    } else {
        style.opacity = 1
    }
    
    return style
}

function render_imgs(props, state, setState, context, history) {
    let ab = []
    let imgs = context.selected_scene_data.AudioBoxes[props.index].imgs

    imgs.slice(0).reverse().map((d, img_index) => {
        
        let src                 = state.img_folder + d.src
        let style               = computeImgStyle(d, state, context, props)
        let box_index           = props.index
        let img_index_reverse   = imgs.length - img_index - 1

        let nav_to = context.selected_scene_data.AudioBoxes[box_index].nav_to

        ab.push(    
                    <img index={ 'audioBox-' + box_index + '-' + img_index_reverse } 
                        key={ img_index }
                        alt="IMG not found" 
                        draggable="false" 
                        className={ "selectable" + " img_" + d.type}
                        src={src} 
                        style={style}

                        //onMouseEnter={ d.type == 'main' ? () => context.activateAudioBox(props.index) : ()=>{} }
                        onMouseEnter={() => context.activateAudioBox(props.index)}
                        onMouseLeave={() => context.deactivateAudioBox()}
                        onClick={ (e) =>{ if(!context.dev_mode){ context.activateAudioBox(props.index); if(nav_to) history.push(nav_to); } else { context.setMoveableElement(e) } } }
                        //onClick={ (e) => context.setMoveableElement(e) }
                        //onClick={ d.type == 'main' ? (e) =>{context.toogleAudioBox(props.index); context.setMoveableElement(e)} : (e)=>{ context.setMoveableElement(e) } }
                        //onClick={ d.type == 'main' ? (e) => {  context.toogleAudioBox(props.index); context.setMoveableElement(e) } : () => {} }
                    /> 
                )
    })
    return ab
}

function getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}